
<template>
    <!-- 場域架構圖 -->
    <div class="container-fluid">
        <h4 class="header-sub">
            {{ $t('menu.field_construction_map') }}
            <b-btn class="btn-collapse-tips" variant="outline-warning" @click="toggle_showControlTips = !toggle_showControlTips">
                {{ $t('menu.op_instructions') }} & {{ $t('menu.filter_tools') }}
            </b-btn>
        </h4>
        <!-- 地圖操作提示 -->
        <div class="collapse-tips-area">
            <b-collapse id="map-control-tips" v-model="toggle_showControlTips">
                <b-card>
                    <div class="card-title">{{ $t('menu.op_instructions') }}</div>

                    <div class="card-text inbox">
                        <div class="instruction-icon">
                            <div class="instruction-map-btn"><i class="fa fa-plus"></i></div>
                        </div>
                        {{ $t('menu.map_instructions_zoom_in') }}
                    </div>
                    <div class="card-text inbox">
                        <div class="instruction-icon">
                            <div class="instruction-map-btn"><i class="fa fa-minus"></i></div>
                        </div>
                        {{ $t('menu.map_instructions_zoom_out') }}
                    </div>
                    <div class="card-text inbox">
                        <div class="instruction-icon">
                            <div class="instruction-map-btn"><div class="text">C</div></div>
                        </div>
                        {{ $t('menu.map_instructions_zoom_reset') }}
                    </div>
                    <div class="card-text inbox">
                        <div class="instruction-icon">
                            <div class="instruction-map-btn"><div class="text-rotate">⇧</div></div>
                        </div>
                        {{ $t('menu.map_instructions_rotate_reset') }}
                    </div>
                    <br>

                    <div class="card-text inbox">
                        <div class="instruction-icon"><i class="fa fa-laptop"></i></div>
                        {{ $t('menu.map_instructions_rotate_laptop') }}
                    </div>

                    <div class="card-text inbox">
                        <div class="instruction-icon"><i class="fa fa-tablet"></i></div>
                        {{ $t('menu.map_instructions_rotate_tablet') }}
                    </div>




                    <div v-if="editMode == false">

                        <hr>

                        <div class="card-title">{{ $t('menu.filter_tools') }}</div>

                        <!-- 裝置分類按鈕 -->
                        <div class="collapse-tips-area">
                            <!-- <h4>{{ $t('n.device') }} {{ $t('menu.status') }}</h4> -->
                            <b-row>
                                <b-col md="12">
                                    <!-- Device Type -->
                                    <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                                        <b-form-group>
                                            <b-form-radio-group v-model="selected_deviceType" buttons size="sm">
                                                <template v-for="(deviceType, key, idx_dt) in result_deviceTypes">
                                                    <b-form-radio v-if="user_admin || deviceType.items.length > 0" :key="idx_dt"
                                                                    :value="key" :button-variant="deviceType.variant"
                                                    >
                                                        <span v-if="deviceType.i18n != undefined">{{ $t('n.' + deviceType.i18n) }}</span>
                                                        <span v-else>{{ key }}</span>
                                                        ({{ deviceType.items.length }})
                                                    </b-form-radio>
                                                </template>
                                            </b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </b-col>

                                <b-col md="12">
                                    <!-- Device Status -->
                                    <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                                        <b-button-group>
                                            <b-button variant="outline-success" size="sm"
                                                    :pressed="selected_deviceStatus == undefined"
                                                    @click="selected_deviceStatus = undefined">
                                                {{ $t('n.all') }}
                                                ({{ getStatusCount['all'] }})
                                            </b-button>
                                            <template v-for="(status, idx_status) in admin_DeviceStatus_List">
                                                <b-button v-if="checkShowStatusButton(status.value)" :key="idx_status"
                                                        :variant="status.buttonVariant" size="sm"
                                                        :pressed="selected_deviceStatus == status.value"
                                                        @click="selected_deviceStatus = status.value">
                                                    {{ $t('status.device.' + status.value) }}
                                                    ({{ getStatusCount[ status.value ] }})
                                                </b-button>
                                            </template>
                                        </b-button-group>
                                    </div>
                                </b-col>
                            </b-row>

                        </div>


                    </div>


                </b-card>
            </b-collapse>
        </div>

        <!-- 地圖使用篩選警告 -->
        <div v-if="selected_deviceType != 'all' || selected_deviceStatus != undefined" class="collapse-tips-area">
            <b-alert show variant="warning">
                <div class="block-text-md"><i class="fa fa-warning"></i>{{ $t('other.map_filter_warning') }}</div>
                <b-button variant="warning" @click="toggle_showControlTips = true">{{ $t('other.open_filter_tools') }}</b-button>
            </b-alert>
        </div>

        <!-- 地圖背景切換 -->
        <div v-if="user_admin" class="collapse-tips-area">
            <b-button-group>
                <b-button variant="outline-dark" :pressed="osm.Show_BasicMapType == 'GoogleMap'" @click="switchOSM_MapLayers('GoogleMap')">{{ $t('menu.map_satellite') }}</b-button>
                <b-button variant="outline-dark" :pressed="osm.Show_BasicMapType == 'Default'" @click="switchOSM_MapLayers('Default')">{{ $t('menu.map_street') }}</b-button>
            </b-button-group>
        </div>



        <b-row>
            <b-col :md="( editMode ? 10 : 10 )">

                <!-- 地圖顯示 -->
                <div id="map-target" class="map-display"></div>

                <!-- 地圖上泡泡資訊 -->
                <div id="popup" class="ol-popup">
                    <div id="popup-closer" class="ol-popup-closer device" @click="closePopop"></div>
                    <div id="popup-content">
                        <div v-if="osm.clickFeature" class="device-name">

                            <!-- 顯示期作資訊 -->
                            <div v-if="osm.clickFeature.type == 'boundary'">
                                <i :class="$tools.style.classIcon('cropperiod', 'block-text')"></i>
                                {{ osm.clickFeature.name }}

                                <b-badge :variant="$tools.style.variantStatusButton('cropperiod', osm.clickFeature.status, false)"
                                        class="block-text">
                                    {{ $t('status.cropperiod.' + osm.clickFeature.status ) }}
                                </b-badge>

                                <div v-if="popup_data">
                                    <!-- 開始日期 -->
                                    <div>
                                        <i class="fa fa-caret-right"></i>
                                        <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                        <div class="block-text">{{ popup_data.start_date }}</div>
                                        <div class="block-text">( {{ popup_data.count_plantingDays }} {{ $t('u.days_ago') }} )</div>
                                    </div>

                                    <i class="fa fa-caret-right"></i>{{ $t('menu.description') }}： {{ popup_data.description }}


                                    <!-- 田區 -->
                                    <div>
                                        <i class="fa fa-caret-right"></i>
                                        <div class="block-text">{{ $t('n.field') }}:</div>
                                        <div class="block-text">{{ popup_data.farm_field }}</div>
                                    </div>

                                    <!-- 面積 & 栽培密度 -->
                                    <div>
                                        <UnitConvertorArea :area="popup_data.area" :density="popup_data.density" defaultUnit="m2" :timezone="popup_data.project_timezone"
                                                            pageType="cropperiod" selectorType="dropdown"></UnitConvertorArea>
                                    </div>

                                    <!-- 積溫 -->
                                    <div v-if="popup_data.whole_percentage">
                                        <div class="progressbar-title">
                                            <i class="wi wi-stars block-text"></i>{{ $t('menu.crop_growth_progress') }}
                                        </div>
                                        <b-progress animated :max="100" class="mb-3 progressbar-bg">
                                            <b-progress-bar class="progressbar-cropperiod" :value="popup_data.whole_percentage">
                                                {{ popup_data.whole_percentage }} %
                                            </b-progress-bar>
                                            <!-- <b-progress-bar variant="success" :value="10" :label="progress"></b-progress-bar> -->
                                            <!-- <b-progress-bar variant="info" :value="30"></b-progress-bar> -->
                                        </b-progress>
                                    </div>
                                </div>
                                <div class="ol-popup-detail">
                                    <b-button variant="success" class="btn-cp" size="sm"
                                              :to="{ name:'Cropperiod', params:{ projectID: projID, cropperiodID: osm.clickFeature.id } }">
                                        {{ $t('menu.detail') }}
                                    </b-button>
                                </div>
                            </div>
                            <!-- 顯示裝置資訊 -->
                            <div v-else>
                                <i :class="$tools.style.classIcon(osm.clickFeature.type, 'block-text')"></i>
                                {{ osm.clickFeature.id }} <br>
                                {{ osm.clickFeature.name }}
                                <b-badge v-if="osm.clickFeature.type != 'gateway'"
                                        :variant="$tools.style.variantStatusButton('device', osm.clickFeature.status, false)"
                                        class="block-text">
                                    {{ $t('status.device.' + osm.clickFeature.status ) }}
                                </b-badge>

                                <div v-if="loading" class="ol-popup-detail scroll-style text-muted">
                                    <i class="fa fa-spinner faa-spin animated"></i> {{ $t('other.loading') }}
                                </div>
                                <div v-else-if="popup_data" class="ol-popup-detail grab-bing scroll-style">

                                    <div v-if="popup_data.last_record">
                                        <div v-if="osm.clickFeature.type == 'camera'">
                                            <i class="fa fa-caret-right"></i> {{ $t('menu.updated') }}: {{ popup_data.last_record.log_time }}
                                            <div>
                                                <b-img fluid rounded
                                                    :src="$config.checkURL('photo', popup_data.last_record.file_path)"
                                                    @click="$tools.ui.openNewPage( popup_data.last_record.file_path )"
                                                    :alt="'photo: ' + popup_data.last_record.file_name">
                                                </b-img>
                                            </div>
                                            <br>
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-caret-right"></i> {{ $t('menu.updated') }}: {{ popup_data.last_record.time }}

                                            <div>
                                                <i class="fa fa-caret-right"></i> {{ $t('menu.latest_data') }}:
                                                <div class="ol-popup-record-data device">
                                                    <div v-for="(param, idx_pa) in osm.clickFeature.visualization" :key="idx_pa" class="device-sensor">
                                                        <template v-if="param == 'wind_direction'">
                                                            <div class="device-sensor-blocks">{{ $t('sensor.wind_direction') }}</div>
                                                            {{ $t('wind.' + popup_data.last_record['wind_direction_key'] ) }}
                                                        </template>

                                                        <template v-else-if="param == 'voltage'">
                                                            <div class="device-sensor-blocks">{{ $t('sensor.voltage_to_battery_percentage') }}</div>
                                                            {{ popup_data.last_record['voltage_to_battery_percentage'] }}
                                                            <div class="device-unit" v-html="$t('sensor.u_voltage_to_battery_percentage')"></div>
                                                        </template>

                                                        <template v-else-if="param == 'rssi'">
                                                            <div class="device-sensor-blocks">{{ $t('sensor.rssi') }}</div>
                                                            <template v-if="popup_data.last_record['rssi_to_signal_bar']">

                                                                <i  class="fa fa-star"
                                                                    v-for="(star, idx_star) in popup_data.last_record['rssi_to_signal_bar']" :key="idx_star"
                                                                ></i>

                                                            </template>
                                                        </template>

                                                        <template v-else-if="param == 'snr'">
                                                            <div class="device-sensor-blocks">{{ $t('sensor.' + param) }}</div>
                                                            {{ popup_data.last_record[ param ] }}
                                                            <div class="device-unit" v-html="$t('sensor.u_' + param)"></div>
                                                            <span v-if="popup_data.last_record['snr'] != undefined && popup_data.last_record['snr'] > 10"> ( 良好 )</span>
                                                        </template>

                                                        <template v-else>
                                                            <div class="device-sensor-blocks">{{ $t('sensor.' + param) }}</div>
                                                            {{ popup_data.last_record[ param ] }}
                                                            <div class="device-unit" v-html="$t('sensor.u_' + param)"></div>
                                                        </template>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- 無七天內資料 -->
                                    <div v-else><i class="fa fa-caret-right"></i> {{ $t('menu.no_data_in_7_days') }}</div>

                                    <div>
                                        <i class="fa fa-caret-right"></i> {{ $t('menu.cropperiods_binded') }}：
                                        <div v-if="popup_data.cropperiods.length > 0">
                                            <b-button v-for="(cpData, idx_cpData) in popup_data.cropperiods" :key="idx_cpData"
                                                    variant="success" class="btn-cp" size="sm"
                                                    :to="{ name:'Cropperiod', params:{ projectID: projID, cropperiodID: cpData.id } }">
                                                <i :class="$tools.style.classIcon('cropperiod', 'block-text')"></i>{{ cpData.name }}
                                            </b-button>
                                        </div>
                                        <div v-else class="block-text">---</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="osm.clickCoordinate" class="ol-popup-coordinate">
                            <i class="fa fa-map-marker block-text"></i> {{ osm.clickCoordinate }}
                            <a :href="'https://www.google.com/maps/place/' + osm.clickCoordinate" target="_blank">
                                ( <span class="block-text">{{ $t('menu.open_in_google_map') }}</span>
                                <i class="fa fa-external-link"></i> )
                            </a>
                        </div>
                    </div>
                </div>

            </b-col>
        </b-row>



        <!-- [ editMode 編輯模式 ] 地圖編輯工具 -->
        <div v-if="editMode">
            <div class="tab-style-management">
                <b-tabs v-model="tabIndex" class="info-tabs" content-class="info-tab-content">
                    <b-tab class="info-tab">
                        <template slot="title">
                            <i class="fa fa-map block-text"></i>{{ $t('menu.map_coordinate') }}
                        </template>
                    </b-tab>
                    <b-tab class="info-tab">
                        <template slot="title">
                            <i class="fa fa-map-marker block-text"></i>{{ $t('n.device') }} {{ $t('menu.coordinate') }}
                        </template>
                    </b-tab>
                </b-tabs>
            </div>

            <div v-if="tabIndex == 0" class="map-tab-body">
                <!-- <h4>{{ $t('menu.coordinate') }} {{ $t('menu.toolbox') }}</h4> -->
                <div v-if="osm.mapCoordinate" class="block-text">
                    {{ $t('menu.mouse_coordinate') }}：
                    <code class="map-coordinate">[ {{ osm.mapCoordinate[1].toFixed(coordinateFixed) }}, {{ osm.mapCoordinate[0].toFixed(coordinateFixed) }} ]</code>

                    <hr>
                </div>
                <div>
                    <h4 v-text="$t('menu.map_coordinate')">地圖中心座標</h4>
                    <b-row>
                        <b-col md="3">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.latitude') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model="projInfo.latitude" :state="checkLatitude"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.longitude')
                                        }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model="projInfo.longitude" :state="checkLongtitude"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.map_zoom') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model="projInfo.zoom" :state="checkZoom"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <div class="block-sm">
                                <button class="btn btn-outline-success" @click="setMap_Center(true)" :disabled="uploading || checkDisabled_MapCenter">
                                    <i class="fa fa-arrow-circle-up"></i>{{ $t('menu.coordinate') }} {{ $t('menu.preview') }}
                                </button>
                            </div>
                            <div class="block-sm">
                                <button class="btn btn-outline-success" @click="getMap_Center" :disabled="uploading">
                                    <i class="fa fa-arrow-circle-down"></i>{{ $t('menu.map_get_current') }}
                                </button>
                            </div>
                            <div class="block-sm">
                                <button class="btn btn-outline-success" @click="get_UserLocation('project')" :disabled="uploading">
                                    <i class="fa fa-map-marker"></i>{{ $t('menu.get_geo_location') }}
                                </button>
                            </div>
                        </b-col>
                        <b-col md="12" class="text-center">
                            <div class="block-sm">
                                <button class="btn btn-secondary" @click="setMap_Center(false)">
                                    C - {{ $t('menu.map_instructions_zoom_reset') }}
                                </button>
                            </div>
                            <div class="block-sm">
                                <button class="btn btn-success" @click="updateMapCenter" :disabled="uploading || checkDisabled_MapCenter">
                                    {{ $t('menu.map_coordinate') }} - {{ $t('menu.save_changes') }}
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div v-if="tabIndex == 1" class="map-tab-body">
                <!-- 裝置編輯工具 -->
                <div v-if="getGateways" class="device-info-area text-left">
                    <b-form-group>
                        <b-form-radio-group v-model="selected_device" name="radioSubComponent" :disabled="editDevicePosition"
                                            v-for="(gateway, idx_g) in getGateways" :key="idx_g">

                            <b-form-radio v-if="user_admin" class="device-select-block" :value="gateway">
                                <span class="device-name clickable">
                                    <i :class="$tools.style.classIcon(gateway.type, 'block-text')"></i>
                                    <span v-if="gateway.nickname != undefined">{{ gateway.nickname }}</span>
                                    <span v-else class="err-msg">[ {{ $t('menu.no_name') }} ]</span>
                                    <span class="device-hashid">{{ gateway.hashid }}</span>
                                    <span class="device-hashid">( ID= {{ gateway.gatewayid }} )</span>
                                    <!-- <code>
                                    [
                                        {{ $tools.num.fixFloat( gateway.latitude, coordinateFixed ) }},
                                        {{ $tools.num.fixFloat( gateway.longitude, coordinateFixed ) }}
                                    ]
                                    </code> -->
                                </span>
                            </b-form-radio>
                            <b-form-radio v-for="(device, idx_d) in gateway.devices" :key="idx_d"
                                        class="device-select-block"
                                        :value="device">
                                <span class="device-name clickable">
                                    <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>
                                    <span v-if="device.nickname != undefined">{{ device.nickname }}</span>
                                    <span v-else class="err-msg">[ {{ $t('menu.no_name') }} ]</span>
                                    <span class="device-hashid">{{ device.hashid }}</span>
                                    <span v-if="user_admin" class="device-hashid">( ID= {{ device.deviceid }} )</span>
                                    <!-- <code>
                                    [
                                        {{ $tools.num.fixFloat( device.latitude, coordinateFixed ) }},
                                        {{ $tools.num.fixFloat( device.longitude, coordinateFixed ) }}
                                    ]
                                    </code> -->
                                </span>
                            </b-form-radio>

                        </b-form-radio-group>
                    </b-form-group>

                    <br>

                    <b-row>
                        <b-col md="6">
                            {{ $t('n.device') }} {{ $t('menu.coordinate') }}：
                            <div v-if="selected_device">
                                <code v-if="selected_device.coordinates != undefined">
                                    <!-- {{ selected_device.coordinates }} -->
                                    [ {{ selected_device.coordinates[1] }}, {{ selected_device.coordinates[0] }} ]
                                </code>
                                <code v-else>{{ $t('menu.no_data') }}</code>

                                <!-- <b-row v-if="editDevicePosition">
                                    <b-col md="6">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend>
                                                <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.latitude') }}</b-input-group-text>
                                            </b-input-group-prepend>
                                            <b-form-input type="text" class="form-control" v-model="selected_device.coordinates[1]" :state="checkLatitude"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend>
                                                <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.longitude')
                                                    }}</b-input-group-text>
                                            </b-input-group-prepend>
                                            <b-form-input type="text" class="form-control" v-model="selected_device.coordinates[0]" :state="checkLongtitude"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->
                            </div>
                        </b-col>
                        <b-col md="4" align-self="end">
                            <div v-if="editDevicePosition">
                                <div class="block-sm">
                                    <button class="btn btn-outline-success block-text" @click="get_UserLocation('device')">
                                        <i class="fa fa-map-marker"></i>{{ $t('menu.get_geo_location') }}
                                    </button>
                                </div>

                                <br>

                                <button class="btn btn-secondary block-text" @click="toggleEditDevicePosition(false)">
                                    {{ $t('menu.cancel') }}
                                </button>
                                <button class="btn btn-success block-text" @click="updateMapDevicePosition" :disabled="selected_device.coordinates == ghost_position">
                                    {{ $t('menu.save_changes') }}
                                </button>
                            </div>
                            <div v-else>
                                <button class="btn btn-success block-text" @click="toggleEditDevicePosition(true)" :disabled="selected_device == undefined">
                                    {{ $t('menu.editting') }}
                                </button>
                            </div>
                        </b-col>
                        <b-col md="2"></b-col>
                    </b-row>





                </div>
            </div>
        </div>

        <!-- <div v-if="editMode" class="map-toolbox map-display">
            <div class="map-toolbox-title">{{ $t('menu.map_toolbox') }}</div>
            <div class="map-toolbox-body">
                <div v-if="project_detail.cropperiods">
                    <h5 class="card-title">KML reader</h5>
                    <b-form-file v-model="fileKML" :state="Boolean(fileKML)"
                                 accept=".kml"
                                 placeholder="Choose a file...">
                    </b-form-file>
                    <div class="mt-3">Selected file: {{ fileKML && fileKML.name }}</div>
                    <b-form-group>
                        <b-form-radio-group v-model="selected_cropperiod" name="radioSubComponent"
                                            v-for="(cropP, idx_cp) in project_detail.cropperiods" :key="idx_cp">
                            <b-form-radio :value="cropP.id">{{ cropP.id }} {{ cropP.name }}</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-button @click="uploadFiles('KML')">Upload</b-button>
                </div>
            </div>

        </div> -->

    </div>
</template>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Overlay from 'ol/Overlay.js';
import TileLayer from 'ol/layer/Tile.js';
import XYZSource from 'ol/source/XYZ';
import {fromLonLat} from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import KML from 'ol/format/KML';

import {defaults as defaultInteractions, Pointer as PointerInteraction, DragRotateAndZoom} from 'ol/interaction.js';
import {defaults as defaultControls, Attribution} from 'ol/control.js';
import MousePosition from 'ol/control/MousePosition.js';
import {createStringXY} from 'ol/coordinate.js';
import OSM from 'ol/source/OSM.js';

import olApp from '@/openlayers/ol_app'
import olTools from '@/openlayers/ol_tools'
import olStyle from '@/openlayers/ol_style'

import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import UnitConvertorArea from '@/views/components/UnitConvertor_Area'


export default {
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        UnitConvertorArea,
    },
    props: {
        showControlTips: {
            type: Boolean,
            default: true,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        coordinateFixed: {
            type: [String, Number],
            default: 6,
        },
    },
    data () {
        return {
            loading:false,
            uploading: false,
            tabIndex: 0,
            toggle_showControlTips: true,

            // popup
            popup_data: undefined,

            // edit tools
            ghost_position: undefined,
            editDevicePosition: false,
            selected_device: undefined,

            selected_cropperiod: undefined,
            fileKML: undefined,
            projInfo: {},

            // device type select tools
            result_devices: [],
            result_deviceTypes: {
                all: { variant: 'outline-success', items: [] },
            },
            selected_deviceType: 'all',
            selected_deviceStatus: undefined,

            // OSM tools
            osm: {
                // --------------------------------------------------
                // Create Open Street Map
                // --------------------------------------------------
                // BasicMap: undefined,
                Map: undefined,
                View: undefined,
                Overlay: undefined,

                Devices: undefined,
                FarmLayers: [],
                FeatureOverlay: undefined,

                Show_BasicMapType: 'GoogleMap',
                mapCoordinate: undefined,

                // --------------------------------------
                // Parameter 預設參數
                // --------------------------------------
                target: 'map-target',
                projection: 'EPSG:4326',
                center_map: [121, 23.5 + 0.1], //center of taiwan
                zoom: 8.2, //7.8
                zoom_max: 2.8,
                zoom_min: 3.8,

                // --------------------------------------
                // Interval 參數
                // --------------------------------------
                timer: '',
                autoUpdateSeconds_flash: 3,
                device_animate: false,

                // --------------------------------------
                // Popup 參數
                // --------------------------------------
                clickCoordinate: '',
                clickFeature: undefined,
                hoverFeature: undefined,
            },
        }
    },
    created ()
    {
        if (this.osm.device_animate)
        {
            let _intervalTime = this.osm.autoUpdateSeconds_flash * 1000;
            this.osm.timer = setInterval(this.flashDeviceLayer, _intervalTime);
        }
    },
    mounted ()
    {
        this.toggle_showControlTips = this.showControlTips;

        let Vue = this;   // 要讓 function 內部可以取用到

        // let mousePositionControl = new MousePosition ({
        //     coordinateFormat: createStringXY(4),
        //     projection: Vue.osm.projection,//'EPSG:4326',
        //     // comment the following two lines to have the mouse position
        //     // be placed within the map.
        //     className: 'show-mouse-coordinate',
        //     target: document.getElementById('mouse-position'),
        //     undefinedHTML: 'mouse not in the map',//'&nbsp;'
        // });

        /**
         * Create an overlay to anchor the popup to the map.
         */
        this.osm.Overlay = new Overlay ({
            element: document.getElementById('popup'),//Vue.osm.Container,
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });

        this.osm.View = new View ({
            projection: Vue.osm.projection,
            center: Vue.osm.center_map,
            maxZoom: Vue.osm.zoom + Vue.osm.zoom_max,
            minZoom: Vue.osm.zoom - Vue.osm.zoom_min,
            zoom: Vue.osm.zoom,
        });

        this.osm.Map = new Map ({
            // 地圖操作設定
            interactions: defaultInteractions({
                doubleClickZoom: false,//Vue.editMode, // 滑鼠雙擊縮放 (editMode 開啟)
                mouseWheelZoom: Vue.editMode,  // 滑鼠滾輪縮放 (editMode 開啟)
                //dragAndDrop: false,
            //   dragPan: false,     // 移動地圖
            //   keyboardPan: false, // 移動地圖
                //keyboardZoom: false,
                //pointer: false,
                //select: false
            }).extend( [ new DragRotateAndZoom() ] ),
            controls: defaultControls ({
                attributionOptions: {
                    collapsible: false
                }
            }).extend( [ new olApp.app.CenterPositionControl() ] ), //, mousePositionControl ] ),
            layers: olTools.setOSM_MapLayers( Vue.osm.Show_BasicMapType, [] ),
            overlays: [ Vue.osm.Overlay ],
            target: Vue.osm.target,
            view: Vue.osm.View,
            pixelRatio: 2,
        });

        // 裝置圖層
        this.osm.Devices = new VectorLayer ({
            name: 'Devices',
            source: new VectorSource ({
                wrapX: false
            }),
            // zIndex: 99,
        });
        this.osm.Map.addLayer(Vue.osm.Devices);


        // 設定 [ 滑鼠移動 ] 事件
        this.osm.Map.on('pointermove', function (evt) {
            if (evt.dragging) {
                // Vue.getMap_Center()  // 因為其他操作還無法自動更新地圖座標與縮放，故先隱藏拖動地圖就更新座標的功能
                return;
            }

            // 偵測到有畫東西就將滑鼠改成可以點擊的手指
            Vue.osm.Map.getTargetElement().style.cursor = Vue.osm.Map.hasFeatureAtPixel(evt.pixel) ? 'pointer' : '';

            Vue.osm.mapCoordinate = evt.coordinate
            Vue.displayFeatureInfo(evt, 'hover');
        });
        // 設定 [ 滑鼠點擊 ] 事件
        this.osm.Map.on('singleclick', function (evt) {

            if (Vue.editDevicePosition)
            {
                Vue.setDeviceCoordinates( evt )
            }
            else
            {
                Vue.displayFeatureInfo(evt, 'click');
            }

            if (Vue.osm.device_animate)
            {
                Vue.flashDeviceLayer();
            }
        });

        this.projInfo = this.$tools.data.deepCopy_object( this.project_detail );
        this.setMap_Center();
        this.setMap_Boundaries();
        // this.setMap_Devices();

        if (this.editMode)
        {
            this.ghost_position = olTools.ghost_position;
            this.osm.View.setMaxZoom( 20 );
            this.osm.View.setMinZoom( 2 );
        }
    },
    computed:
    {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'project_detail': state => state.project.project_detail,
            'project_devices': state => state.project.project_devices,
            'admin_DeviceType_List': state => state.device.list_deviceTypes,
            'admin_DeviceStatus_List': state => state.device.list_status,
        }),

        projID() {
            return this.$route.params.projectID;
        },

        getGateways ()
        {
            if (this.project_devices)
            {
                return this.project_devices.gateways.slice()
            }
            else return []
        },

        checkLongtitude ()
        {
            if (this.projInfo.longitude == undefined) return false
            return this.$tools.input.checkFloat( this.projInfo.longitude );
        },
        checkLatitude ()
        {
            if (this.projInfo.longitude == undefined) return false
            return this.$tools.input.checkFloat( this.projInfo.latitude );
        },
        checkZoom ()
        {
            if (this.projInfo.longitude == undefined) return false
            return this.$tools.input.checkFloat( this.projInfo.zoom );
        },
        checkDisabled_MapCenter () {
            if ( this.checkLongtitude == false ) return true
            if ( this.checkLatitude == false )   return true
            if ( this.checkZoom == false )       return true

            return false;
        },

        getStatusCount ()
        {
            let _statusCount = {
                'all': 0,
                'inventory': 0,
                'shipped': 0,
                'resting': 0,
                'repairing': 0,
                'malfunction': 0,
                'abandon': 0,
            }

            if ( this.result_devices && this.result_devices.length > 0 )
            {
                _statusCount['all'] = this.result_devices.length

                this.result_devices.forEach( _device => {

                    if ( _statusCount[ _device.status ] == undefined ) _statusCount[ _device.status ] = 0

                    _statusCount[ _device.status ] += 1
                })
            }

            return _statusCount
        },
    },
    watch:
    {
        project_detail (val, oldVal)
        {
            if (val)
            {
                this.projInfo = this.$tools.data.deepCopy_object( val );
                this.setMap_Center();
                this.setMap_Boundaries(); // 順便更新地圖框
            }
        },
        project_devices (val, oldVal)
        {
            if (val)
            {
                this.get_DeviceTypes( this.getGateways )
            }
            this.setMap_Devices();
        },
        selected_deviceType (val, oldVal)
        {
            if (val)
            {
                this.result_devices = this.result_deviceTypes[ val ].items
                this.setMap_Devices();
            }
        },
        selected_deviceStatus (val, oldVal)
        {
            this.setMap_Devices();
        },
        tabIndex ()
        {
            this.toggleEditDevicePosition(false)
            this.selected_device = undefined
        },
        selected_device (val, oldVal)
        {
            if ( this.editDevicePosition == false )
            {
                this.toggleEditDevicePosition(true)
            }
        },
    },
    methods:
    {
        get_UserLocation (getLocationType = 'project')
        {
            this.$store.dispatch('user/getUserLocation', this)
                .then( res => {
                    // console.log( res.lat )
                    // console.log( res.lng )

                    if ( res != undefined && res.lat != undefined && res.lng != undefined )
                    {

                        if ( getLocationType == 'project' )
                        {
                            this.projInfo.latitude   = parseFloat( res.lat ).toFixed(this.coordinateFixed)
                            this.projInfo.longitude = parseFloat( res.lng ).toFixed(this.coordinateFixed)

                            this.setMap_Center(true)
                        }
                        else if ( getLocationType == 'device' )
                        {
                            if ( this.editDevicePosition )
                            {
                                let _evt = {
                                    coordinate: [ parseFloat( res.lng ), parseFloat( res.lat ), ] // open street map 是 [ 經度, 緯度 ]
                                }
                                this.setDeviceCoordinates( _evt )
                            }
                        }
                    }
                })
                .catch( err => {

                    this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.message,
                                    `${this.$t('menu.get_geo_location')}`);
                })
        },

        switchOSM_MapLayers (MapType)
        {
            // 把第一層 Layer 取代掉
            this.osm.Map.getLayers().getArray()[0] = olTools.switchOSM_MapLayers( MapType )

            this.osm.Show_BasicMapType = MapType

            // 更新地圖
            this.osm.Map.render()
        },

        get_DeviceTypes (_all_devices)
        {
            // initialize
            this.result_deviceTypes = {
                all:     { variant: 'outline-success', items: [], i18n: 'all' },
            };

            this.admin_DeviceType_List.forEach( _type => {
                this.result_deviceTypes[ _type.type ] = { variant: 'outline-success', items: [], i18n: _type.type };
            })

            if ( _all_devices.length > 0 ) this.result_deviceTypes['gateway'] = { variant: 'outline-success', items: [], i18n: 'gateway' };

            _all_devices.forEach( _gateway => {

                if ( this.user_admin ) this.result_deviceTypes['all'].items.push( _gateway );

                _gateway.type = 'gateway';
                this.result_deviceTypes['gateway'].items.push( _gateway );

                _gateway.devices.forEach( _device => {
                    let _hashType = _device.hashid[0] + _device.hashid[1];
                    _device['device id'] = _hashType + '-' + _device.deviceid

                    this.result_deviceTypes['all'].items.push( _device );

                    // type: weatherbox, wand, camera, extra
                    // if ( this.result_deviceTypes[ _device.type ] == undefined ) { this.result_deviceTypes[ _device.type ] = { variant: 'outline-success', items: [], i18n: _device.type }; }
                    this.result_deviceTypes[ _device.type ].items.push( _device );

                    // hashType: WA, WB, WC, DA, DB, DC, DD, DE, CA, CB, XA, XB, XC, ...
                    if ( this.user_admin )
                    {
                        if ( this.result_deviceTypes[ _hashType ] == undefined ) { this.result_deviceTypes[ _hashType ] = { variant: 'outline-warning', items: [], i18n: undefined }; }
                        this.result_deviceTypes[ _hashType ].items.push( _device );
                    }
                })
            })

            this.result_devices = this.result_deviceTypes['all'].items
            this.selected_deviceType = 'all'

        },
        checkShowStatusButton (status, is_admin = false)
        {
            if (this.user_admin == true) return true
            else if (is_admin == true) return true
            else
            {
                // 檢查當下狀態
                switch (status)
                {
                    case 'inventory': return false;
                    default:          return true;
                }
            }
        },
        getDisplayDevices ()
        {
            if ( this.result_devices )
            {
                if ( this.selected_deviceStatus == undefined )
                {
                    return this.result_devices
                }
                else
                {
                    let _displayList = []
                    this.result_devices.forEach( _device => {
                        if ( _device.status == this.selected_deviceStatus ) _displayList.push( _device )
                    })
                    return _displayList
                }
            }
            return []
        },

        flashDeviceLayer ()
        {
            // console.log('draw devices flash circle')
            olTools.flashDevices( this.osm.Map, this.osm.Devices );
        },

        getViewInfo ()
        {
            console.log(this.osm.View.getCenter());
        },

        getMap_Center ()
        {
            let _center = this.osm.View.getCenter()
            this.projInfo.longitude = _center[0].toFixed(this.coordinateFixed)
            this.projInfo.latitude   = _center[1].toFixed(this.coordinateFixed)
            this.projInfo.zoom       = this.osm.View.getZoom().toFixed(2)
        },

        setMap_Center (preview = false)
        {
            if ( preview == true )
            {
                olTools.previewMap( this.osm,
                                    this.projInfo.longitude,
                                    this.projInfo.latitude,
                                    this.projInfo.zoom );
            }
            else
            {
                olTools.setMap_Center( this.osm,
                                    this.project_detail.longitude,
                                    this.project_detail.latitude,
                                    this.project_detail.zoom );
            }
        },

        setMap_Devices ()
        {
            // console.log( this.getGateways )
            // console.log( this.result_devices )
            // console.log( this.getDisplayDevices )
            olTools.setAllDeviceFeature( this.osm, this.osm.Devices, this.getDisplayDevices(), this.user_admin, this.editMode, this.osm.device_animate )
        },

        setMap_Boundaries ()
        {
            let Vue = this;

            // 先清掉舊的地圖框線
            this.removeMap_Boundaries();

            this.project_detail.cropperiods.forEach( _cp => {

                if (_cp.boundary)
                {
                    let theStyle = olStyle.createPolygonStyle_Farm();
                    theStyle.getText().setText( _cp.name );


                    // 農田邊界圖層
                    let _farm = new VectorLayer ({
                        id: _cp.id,
                        name: _cp.name,
                        type: 'boundary',
                        status: _cp.status,
                        // target: _cp,
                        source: new VectorSource ({
                            projection: Vue.osm.projection,
                            url: _cp.boundary,
                            format: new KML ({
                                extractStyles: false,
                            })
                        }),
                        style: theStyle,
                    });
                    Vue.osm.FarmLayers.push( _farm )
                    Vue.osm.Map.addLayer( _farm );
                }

            })

            // 新增農地地圖後，先移除裝置地圖，再將裝置地圖加入，確保裝置地圖在最上層
            this.osm.Map.removeLayer(this.osm.Devices);
            this.osm.Map.addLayer(this.osm.Devices);
        },
        removeMap_Boundaries ()
        {
            //console.log( this.osm.FarmLayers )
            this.osm.FarmLayers.forEach( _farm => {
                this.osm.Map.removeLayer( _farm )
            })
            this.osm.FarmLayers = []
            //console.log( this.osm.FarmLayers )
        },

        displayFeatureInfo (evt, action)
        {
            let _pixel = this.osm.Map.getEventPixel(evt.originalEvent);
            let _feature = this.osm.Map.forEachFeatureAtPixel( _pixel, function (feature) {
                return feature;
            });

            if (_feature)
            {

                let _featureInfo = {
                    id:             _feature.getId(),
                    name:           _feature.get('name'),
                    type:           _feature.get('type'),
                    status:         _feature.get('status'),
                    visualization:  _feature.get('visualization'),
                };

                this.osm.hoverFeature = _featureInfo;

                if (action == 'click')
                {
                    this.popup_data = undefined

                    // 裝置
                    if ( _feature.getGeometry().getType() == 'Point' )
                    {
                        this.osm.clickFeature = _featureInfo;

                        if ( _featureInfo.type != 'gateway' ) this.get_DeviceSituation( _featureInfo.id );

                        this.showPopup( _feature.getGeometry().getCoordinates() );
                    }
                    // 期作輪廓
                    else if ( _feature.getGeometry().getType() == 'Polygon' )
                    {
                        this.osm.Map.getLayers().forEach( _layer => {
                            if ( _layer.getProperties().type == 'boundary' )
                            {
                                if ( _layer.getSource().hasFeature(_feature) )
                                {
                                    _featureInfo = {
                                        id:     _layer.getProperties().id,
                                        name:   _layer.getProperties().name,
                                        type:   _layer.getProperties().type,
                                        status: _layer.getProperties().status,
                                        // target: _layer.getProperties().target,
                                    }

                                    this.osm.clickFeature = _featureInfo;

                                    this.popup_data = this.get_Cropperiod( _featureInfo.id )

                                    this.showPopup( evt.coordinate );
                                }
                            }
                        })
                    }
                }

            }
            else
            {
                this.osm.hoverFeature = undefined;

                if (action == 'click')
                {
                    this.showPopup(undefined);
                }
            }

        },

        showPopup (coordinate)
        {
            if (coordinate)
            {
                this.osm.clickCoordinate = coordinate[1].toFixed(this.coordinateFixed) + ',  ' + coordinate[0].toFixed(this.coordinateFixed);
            }
            else this.osm.clickCoordinate = '';

            this.osm.Overlay.setPosition(coordinate);
        },
        closePopop ()
        {
            this.osm.Overlay.setPosition(undefined);
            return false;
        },

        toggleEditDevicePosition (edit = false)
        {
            if (edit)
            {
                this.closePopop()
                this.editDevicePosition = true
            }
            else
            {
                this.setDeviceCoordinates(undefined, 'cancel')
                this.editDevicePosition = false
            }
        },
        setDeviceCoordinates (evt, action = 'set')
        {
            let _device = this.selected_device
            if (_device)
            {
                let _selected_featureID = _device.hashid
                let _source = this.osm.Devices.getSource();
                let _feature = _source.getFeatureById( _selected_featureID );
                // console.log( _feature )

                if (action == 'set')
                {
                    _device.coordinates = [ evt.coordinate[0].toFixed(this.coordinateFixed), evt.coordinate[1].toFixed(this.coordinateFixed) ];
                    _feature.getGeometry().setCoordinates( _device.coordinates );
                }
                else if (action == 'cancel')
                {
                    // 如果原本有設經緯度，就還原
                    if (_device.longitude && _device.latitude)
                    {
                        // 注意：OSM 的座標是 [ 經度, 緯度 ] !!!! ( ps.我們介面上顯示 [ 緯度, 經度 ] )
                        _device.coordinates = [ _device.longitude, _device.latitude ]
                        _feature.getGeometry().setCoordinates( _device.coordinates );
                    }
                    else
                    {
                        _device.coordinates = undefined
                        _feature.getGeometry().setCoordinates( olTools.ghost_position );
                    }

                }
            }
        },
        getProjectDevices (_projectID)
        {
            this.$store.dispatch('project/getProjectDevices', _projectID)
                .then( res => {
                    this.selected_device = undefined
                    this.editDevicePosition = false
                })
                .catch( err => {
                })
        },
        updateMapDevicePosition ()
        {
            this.uploading = true;
            let _device = this.selected_device
            let _url = ''

            let _latitude   =  parseFloat( _device.coordinates[1] )
            let _longitude =  parseFloat( _device.coordinates[0] )
            let _data = {
                latitude:       _latitude.toFixed(this.coordinateFixed),
                longitude:     _longitude.toFixed(this.coordinateFixed),
            }

            if (this.user_admin)
            {
                if (_device.type == 'gateway')  { _url = this.$config.getAPI_URL('Admin_Gateway', { projectID: this.projID, gatewayID: _device.hashid }) }
                else                            { _url = this.$config.getAPI_URL('Admin_Device', { projectID: this.projID, deviceID: _device.hashid }) }
            }
            else
            {
                _url = this.$config.getAPI_URL('Update_Project_Device_Info', { projectID: this.projID, deviceID: _device.hashid })
            }

            const options = {
                method: 'PUT',
                url: _url,
                data: _data
            }
            this.$http(options)
                .then(res => {
                    this.uploading = false;
                    this.getProjectDevices(this.projID);

                    this.$toastr.s(this.$t('other.update_succeeded'),
                                    `${this.$t('n.device')} ${this.$t('menu.coordinate')}：<br>${_device.hashid} ${_device.nickname}<br>[ ${_data.latitude}, ${_data.longitude} ]`);
                })
                .catch(err => {
                    this.uploading = false;
                    this.toggleEditDevicePosition(false);
                    this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    `${this.$t('n.device')} ${this.$t('menu.coordinate')}：<br>${_device.hashid} ${_device.nickname}<br>[ ${_data.latitude}, ${_data.longitude} ]`);
                })

            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'map - device',
                    action: 'update position',
                    querySettings: {
                        'project ID':       this.projID,
                        'project name':     this.project_detail.name,
                        'project status':   this.project_detail.status,
                        'service level':    this.project_detail.service_level,
                        'user role':        this.project_detail.user_role,
                        'device ID':        _device.deviceid,
                        'device HashID':    _device.hashid,
                        'device type':      _device.type,
                        'device nickname':  _device.nickname,
                        'device status':    _device.status,
                        'pos change':       '[ ' + _device.latitude + ', ' + _device.longitude + '] ' + ' => [ ' + _data.latitude + ', ' + _data.longitude + ' ]',
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },

        updateMapCenter ()
        {
            this.uploading = true;
            let _latitude   =  parseFloat( this.projInfo.latitude )
            let _longitude =  parseFloat( this.projInfo.longitude )
            let _zoom       =  parseFloat( this.projInfo.zoom )

            let _data = {
                latitude:       _latitude.toFixed(this.coordinateFixed),
                longitude:     _longitude.toFixed(this.coordinateFixed),
                zoom:           _zoom.toFixed(2),
            }

            const options = {
                method: 'PUT',
                url: this.$config.getAPI_URL('Update_Project', { projectID: this.projID }),
                data: _data
            }
            this.$http(options)
                .then(res => {
                    this.uploading = false;

                    // Set Project Detail & Update Map Center
                    // 避免整頁重新 Loading，直接更改 project_detail 資料，不呼叫 API
                    // this.project_detail.latitude   = _data.latitude
                    // this.project_detail.longitude = _data.longitude
                    // this.project_detail.zoom       = _data.zoom
                    // this.setMap_Center()

                    // 取得專案資料
                    this.$store.dispatch('project/getProjectDetail', this.projID)
                        .then(res => {})
                        .catch(err => {})

                    this.$toastr.s(this.$t('other.update_succeeded'), this.$t('menu.map_coordinate'));
                })
                .catch(err => {
                    this.uploading = false;
                    this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    this.$t('menu.map_coordinate'));
                })

            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'map - view',
                    action: 'update position',
                    querySettings: {
                        'project ID':       this.projID,
                        'project name':     this.project_detail.name,
                        'project status':   this.project_detail.status,
                        'service level':    this.project_detail.service_level,
                        'user role':        this.project_detail.user_role,
                        'pos change':       '[ ' + this.project_detail.latitude + ', ' + this.project_detail.longitude + '] ' + ' => [ ' + _data.latitude + ', ' + _data.longitude + ' ]',
                        'zoom change':      this.project_detail.zoom + ' => ' + _data.zoom,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },

        get_Cropperiod (_cpID)
        {
            let _cropperiod = undefined
            if ( this.project_detail )
            {
                this.project_detail.cropperiods.forEach( _cp => {
                    if ( _cp.id == _cpID ) _cropperiod = _cp
                })
                // this.project_detail.done_cropperiods.forEach( _cp => {
                //     if ( _cp.id == _cpID ) _cropperiod = _cp
                // })
                // abandon_cropperiods 就不檢查了
            }
            return _cropperiod
        },
        get_CropperiodsData (list_cropID)
        {
            let _croperiods = []

            list_cropID.forEach( _cpID => {
                let _crop = this.get_Cropperiod(_cpID)
                if ( _crop != undefined )
                    _croperiods.push( _crop )

            })

            return _croperiods
        },
        get_DeviceSituation (hashID)
        {
            this.popup_data = undefined
            if (hashID != undefined && this.project_detail != undefined)
            {
                this.loading = true
                const querysettings = {
                    projectID:  this.project_detail.id,
                    deviceID:   hashID,
                    timezone:   this.project_detail.timezone,
                }
                this.$store.dispatch('device/getDevice_Situation', querysettings)
                    .then( res => {
                        this.loading = false
                        // console.log( res );
                        this.popup_data = res
                        this.popup_data.cropperiods = this.get_CropperiodsData( this.popup_data.cropperiod_ids )
                    })
                    .catch( err => {
                        this.loading = false
                    })

            }
        },


        // uploadFiles (type)
        // {
        //     if (type == 'KML')
        //     {
        //         let _formData = new FormData();
        //         _formData.append('boun', this.fileKML);

        //         const uploadData = {
        //             id: this.selected_cropperiod,
        //             formData: _formData
        //         }
        //         this.$store.dispatch('cropperiod/uploadBoundary', uploadData)
        //             .then( res => {
        //                 console.log('upload ' + this.fileKML.name + ' success !');
        //                 console.log( res );
        //             })
        //             .catch( err => {
        //             })

        //     }
        // },


    },
    beforeDestroy ()
    {
        // Cancel Auto Update
        if (this.osm.device_animate)
        {
            clearInterval(this.osm.timer)
        }
    }
}
</script>


<style lang="scss" scoped>

.collapse-tips-area
{
    margin: 0px 15px;
    .card
    {
        border-color: #F0C851;
    }
    .card-text
    {
        margin-right: 45px;
    }
}

.instruction-icon
{
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-size: 1.8rem;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    color: #cc872d;

    .fa
    {
        margin: 0px;
    }
}

.instruction-map-btn
{
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-size: 1.1rem;
    .fa
    {
        vertical-align: middle;
        font-size: 0.8rem;
        padding: 0px 7px 2px 6px;
    }
    .text
    {
        font-weight: bold;
        padding: 0px 7px 1px 6px;
    }
    .text-rotate
    {
        font-weight: bold;
        padding: 0px 4px 1px 4px;
    }

    color: #dcf2f3;
    background-color: #5ea9ce;
    border-radius: 5px;
    border: 3px solid #c1dce9;
}

</style>
